import { hiddenPasswordPattern } from "constants/constants";
import { UserWorkspaceProfile } from "@models/UserWorkspaceProfile";
import { Box, Button, Stack, Typography, useTheme, styled } from "@mui/material"
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { useForgotPassword } from "hooks/useForgotPassword";
import { ResetPasswordButton } from './LogingInSection.styles';

const StyledButtonContainer = styled(Box)({
  position: 'relative',
  bottom: 0
});

const StyledButtonStack = styled(Stack)({
  position: 'absolute',
  bottom: '16px'
});

export const LogingInSection = (props: {user: UserWorkspaceProfile}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { user } = props;
    const { processForgotPassword, forgotPasswordPending } = useForgotPassword();

    const handleForgotPassword = async () => {
        processForgotPassword({ email: user.email });
    }

    return <Box padding={theme.spacing(2)} height='20%'>
        <Typography variant="h6" fontWeight={'500'}>{t('profile.logingIn')}</Typography>
        <Stack direction={'row'} padding={theme.spacing(2)}>
            <Box width='50%'>
                <Stack width='50%'>
                    <Typography variant="caption">{t('general.email')}</Typography>
                    <Typography variant="subtitle2" fontSize={'16px'}>{user.email}</Typography>
                </Stack>
                <Stack width='50%'>
                    <Typography variant="caption">{t('general.password')}</Typography>
                    <Typography variant="subtitle2" fontSize={'16px'}>{hiddenPasswordPattern}</Typography>
                </Stack>
            </Box>
            <StyledButtonContainer width='50%'>
                <StyledButtonStack direction={'row'} width='100%' display={'flex'} justifyContent={'center'}>
                    <ResetPasswordButton loading={forgotPasswordPending} disabled={!user.emailConfirmed} variant='outlined' onClick={handleForgotPassword}>{t('profile.resetPassword')}</ResetPasswordButton>
                </StyledButtonStack>
            </StyledButtonContainer>
        </Stack>
    </Box>
}